import { useCallback } from 'react';

const getWindow = () => {
  return window;
};

const useWindow = () => {
  const windowObject = getWindow();

  const getFromWindow = useCallback(
    (key) => {
      try {
        return !!windowObject && windowObject[`${key}`] ? windowObject[`${key}`] : null;
      } catch (error) {
        return null;
      }
    },
    [windowObject]
  );

  const assignToWindow = useCallback(
    (key, value) => {
      if (windowObject) {
        windowObject[`${key}`] = value;
      }
    },
    [windowObject]
  );

  const openNewWindow = useCallback(
    (url, target, features) => {
      if (windowObject) {
        windowObject.open(url, target, features);
      }
    },
    [windowObject]
  );

  return [getFromWindow, assignToWindow, openNewWindow];
};

export default useWindow;
